import { Button, Modal } from '@msaf/core-react'
import { useMutationWithToast } from '../../../../hooks/use-mutation-with-toast'
import { useNavigate, useParams } from 'react-router-dom'

export function DeletePlanModal({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (state: boolean) => void }) {
  const navigate = useNavigate()
  const { id: planId } = useParams()

  const mutation = useMutationWithToast({
    method: 'DELETE',
    url: `api/plan/${planId}`,
    success: {
      toastMessage: 'SRP has been successfully deleted.',
      action: () => navigate(`/plans`),
    },
    error: {
      toastMessage: 'Unable to delete the SRP.',
      action: () => {
        setIsOpen(false)
      },
    },
  })

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      heading='Delete SRP?'
      body='Are you sure you wish to delete this SRP?'
      contentLabel='Confirm SRP deletion'
      buttons={
        <>
          <Button
            buttonStyle='danger'
            type='button'
            icon='trash'
            label='Delete SRP'
            onClick={() => mutation.mutate(null)}
          />
          <Button buttonStyle='text-action' type='button' label='Cancel' onClick={() => setIsOpen(false)} />
        </>
      }
    />
  )
}
